import { Component } from '@angular/core';

@Component({
  selector: 'app-user-management-icon',
  imports: [],
  templateUrl: './user-management-icon.html',
  styleUrl: './user-management-icon.scss',
})
export class UserManagementIcon {}
